import React, {useEffect, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import useHandleCloseModal from '../../../hooks/HandleCloseModal'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import Swal from 'sweetalert2'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {ISection, ITemplateAnalytic} from '../../../interfaces/Analytics/Analytics'
import clsx from 'clsx'
import {handleCaps, truncateText} from '../../../functions/general'
import {insertSection, updateSection} from '../../../api/Analitik/SectionCRUD'
import useAccessToken from '../../../hooks/AccessToken'
import {useAnalyticsStore} from '../../../stores/Analytics/AnalyticStore'
import {updateAccessTemplate, updateTemplate} from '../../../api/Analitik/TemplateCRUD'
import useSWR, { mutate } from 'swr'
import axios from 'axios'
import {User} from '../../../interfaces/User'
import VirtualizedSelect, {VirtualizedSelectOption} from '../../Select/SelectVirtualized'
import Select, { components, SingleValueProps, OptionProps, StylesConfig } from "react-select";
import { SelectOption } from '../../../interfaces/SelectOption'
import useUser from '../../../hooks/User'


interface IProps {
  template: ITemplateAnalytic
}
interface IDataUser {
  name: string
  userId: string
  access: string
}
interface FormikValues {
  dataUsers: string[]
  access: string
}
export default function UpdateAccessTemplate({template}: IProps) {
  const intl = useIntl()
  const user = useUser()
  const modalRef = useRef<HTMLDivElement | null>(null)
  const closeModalRef = useRef<HTMLButtonElement>(null)
  // const [modalBtnLoading, setModalBtnLoading] = useState(false)
  const [addRoleBTNLoading, setAddRoleBTNLoading] = useState(false)
  const [updateRoleBTNLoading, setUpdateRoleBTNLoading] = useState(false)
  const {setTemplatesAnalytic, templatesAnalytic} = useAnalyticsStore()
  const token = useAccessToken()
  const [responsibleOptions, setResponsibleOptions] = useState<VirtualizedSelectOption[]>([])
  const roleAnalyticOption: VirtualizedSelectOption[] = [
    {value: 'VIEWER', label: 'Viewer'},
    {value: 'EDITOR', label: 'Editor'},
    {value: '', label: 'Remove Access'},
  ]
  const roleAnalyticOptionWithRemove: VirtualizedSelectOption[] = [
    {value: 'VIEWER', label: 'Viewer'},
    {value: 'EDITOR', label: 'Editor'},
    {value: '', label: 'Remove Access'},
  ]

  const formik = useFormik<FormikValues>({
    initialValues: {
      dataUsers: [],
      access: 'VIEWER',
    },
    validationSchema: Yup.object().shape({
      dataUsers: Yup.array().nullable(),
    }),
    onSubmit: async (values, {setStatus, setSubmitting}) => {},
  })

  const [userAccessData, setUserAccessData] = useState<IDataUser[]>([])
  const [userAccessDataTemp, setUserAccessDataTemp] = useState<IDataUser[]>([])
  const [areAnyUpdate, setAreAnyUpdate] = useState<boolean>(false)
  const customStyles: StylesConfig<SelectOption, false> = {
    option: (provided, state) => ({
      ...provided,
      paddingLeft: state.data.value!=='' ? "24px":"12px",
    }),
  };
  const Option: React.FC<OptionProps<SelectOption, false>> = (props) => {
   
    if (props.data.value === "") {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px", borderTop: "2px solid rgba(128, 128, 128, 0.5)" }}>
          <components.Option {...props} />
        </div>
      );
    }
      return(
        <components.Option
        className='option-access-padding'
        {...props}
      />
      )
    
  };

  useEffect(() => {
    const areAnyUpdateChecker =
      JSON.stringify(userAccessData) !== JSON.stringify(userAccessDataTemp)
    setAreAnyUpdate(areAnyUpdateChecker)
  }, [userAccessData, userAccessDataTemp])

  const handleAddRole = async () => {
    setAddRoleBTNLoading(true)
    try {
      const dataUserUpdateRole = formik.values.dataUsers.map((user) => {
        return {
          userId: user,
          access: formik.values.access,
        }
      })
      const mergedUserAccessData = [
        ...userAccessData.map((user) => {
          // Cek apakah user.id ada di dataUserUpdateRole
          const updatedUser = dataUserUpdateRole.find((u) => u.userId === user.userId)
          return updatedUser ? {...user, access: updatedUser.access} : user
        }),
        ...dataUserUpdateRole.filter(
          (user) => !userAccessData.some((existingUser) => existingUser.userId === user.userId)
        ),
      ]
      const response = await updateAccessTemplate(mergedUserAccessData, template.id, token)
      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          heightAuto: false,
          title: intl.formatMessage({id: 'FORM.VALIDATION.UPDATE_ACCESS_SUCCESS'}),
          timer: 2000,
          timerProgressBar: true,
        })
        setUserAccessData(response.data.data.dataUsers)
        setUserAccessDataTemp(response.data.data.dataUsers)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    } finally {
      formik.resetForm()
      setAddRoleBTNLoading(false)
    }
  }

  const handleUpdateRole = async (e:any) => {
    if (!areAnyUpdate) {
      closeModalRef.current?.click()
      return
    }
    setUpdateRoleBTNLoading(true)
    try {
      const response = await updateAccessTemplate(userAccessDataTemp, template.id, token)
      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          heightAuto: false,
          title: intl.formatMessage({id: 'FORM.VALIDATION.UPDATE_ACCESS_SUCCESS'}),
          timer: 2000,
          timerProgressBar: true,
        })
        setUserAccessData(response.data.data.dataUsers)
        setUserAccessDataTemp(response.data.data.dataUsers)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    } finally {
      setUpdateRoleBTNLoading(false)
    }
  }
  const API_URL = process.env.REACT_APP_API_URL

  const fetcher = (url: string) => {
    let params = {}

    if (url === `${API_URL}/analytics/template/access`) {
      params = {
        templateId: template.id,
      }
    }

    return axios
      .get(url, {
        headers: {
          'X-Auth-token': token,
        },
        params,
      })
      .then((res) => res.data.data)
  }
  const {
    data: responsibleData = [],
    error: responsibleError,
    isLoading: responsibleLoading,
  } = useSWR(`${API_URL}users`, fetcher)

  const {
    data: _userAccessData,
    error: userAccessDataError,
    isLoading: userAccessDataLoading,
    isValidating: useAccessDataValidating,
  } = useSWR(`${API_URL}/analytics/template/access`, fetcher)

  useEffect(() => {
    if (_userAccessData?.dataUsers.length >= 0) {
      setUserAccessData(_userAccessData.dataUsers)
      setUserAccessDataTemp(_userAccessData.dataUsers)
    }
  }, [_userAccessData])

  const {handleCloseModal} = useHandleCloseModal(modalRef, closeModalRef, formik,undefined, ()=>{
    setUserAccessData([])
    setUserAccessDataTemp([])
  })

  useEffect(() => {
    const responsibleOpt = responsibleData.filter((u:User)=>u.id!==user.data.id).map((user: User) => {
      return {
        value: user.id,
        label: user.name,
      }
    })

    // Menambahkan opsi "Semua User"
    const allUsersOption = {
      value: 'all',
      label: intl.formatMessage({id: 'FORM.OPTION.LABEL.ALL_USER'}),
    }

    // Menambahkan opsi "Semua User" di awal array
    setResponsibleOptions([allUsersOption, ...responsibleOpt])
  }, [responsibleData])

  return (
    <>
      <div
        className={`modal fade`}
        tabIndex={-1}
        id={`edit-access-template-modal-${template.id}`}
        ref={modalRef}
      >
        <div className='modal-dialog modal-dialog-scrollable'>
          <div className='modal-content '>
            <div className='modal-header'>
              <h5 className='modal-title'>
                {intl.formatMessage({id: 'FORM.ACTION.UPDATE_ACCESS_ANALYTIC'})} {truncateText(template.name, 25)}
              </h5>
              <button
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                onClick={handleCloseModal}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </button>
            </div>
            {/* form */}

            <form onSubmit={formik.handleSubmit} noValidate>
              <div className='modal-body ' style={{height: "70vh"}}>
                <>
                  {/* <label className='form-label fs-6 fw-bolder text-dark '>
                    {intl.formatMessage({id: 'FORM.ACTION.CHOOSE_USER'})}
                  </label> */}
                  <div className=' row '>
                    <div className='col-8'>
                      <Select
                        onChange={(selectedOptions) => {
                          var endIndex = selectedOptions.length - 1
                          if (
                            selectedOptions.length > 0 &&
                            selectedOptions[endIndex].value === 'all'
                          ) {
                            formik.setFieldValue(
                              'dataUsers',
                              responsibleOptions
                                .filter((item) => item.value !== 'all')
                                .map((opt) => opt.value)
                            )
                          } else {
                            formik.setFieldValue(
                              'dataUsers',
                              selectedOptions
                                .filter((item) => item.value !== 'all')
                                .map((opt) => opt.value)
                            )
                          }
                        }}
                        closeMenuOnSelect={false}
                        placeholder={intl.formatMessage({id: 'FORM.ACTION.CHOOSE_USER'})}
                        options={responsibleOptions}
                        value={
                          formik.values.dataUsers.length === responsibleOptions.length - 1
                            ? [
                                {
                                  value: 'all',
                                  label: intl.formatMessage({id: 'FORM.OPTION.LABEL.ALL_USER'}),
                                },
                              ] // Jika "Semua User" dipilih, hanya tampilkan "Semua User"
                            : responsibleOptions.filter((responsible) =>
                                formik.values.dataUsers.includes(responsible.value)
                              )
                        }
                        isMulti={true}
                        // isSort={false}
                      />
                    </div>
                    <div className='col-4'>
                      <Select
                        closeMenuOnSelect={true}
                        options={roleAnalyticOption}
                        value={
                          roleAnalyticOption.filter((role) => {
                            return role.value === formik.values.access
                          })[0]
                        }
                        isClearable={false}
                        onChange={(selectedOptions) => {
                          return formik.setFieldValue('access', selectedOptions?.value)
                        }}
                        isMulti={false}
                        components={{Option}}
                        styles={customStyles}
                        // defaultValue={
                        //   roleAnalyticOption.filter((role) => {
                        //     return role.value === 'VIEWER'
                        //   })[0]
                        // }
                      />
                    </div>
                  </div>
                  {formik.touched.dataUsers && formik.errors.dataUsers && (
                    <div className='fv-plugins-message-container text-danger'>
                      <span role='alert' className='text-danger'>
                        {formik.errors.dataUsers}
                      </span>
                    </div>
                  )}
                </>
                <div className='my-4'>
                  <h4>{intl.formatMessage({id:"ANALYTICS.HEADER.PEOPLE_WITH_ACCESS"})}</h4>
                  <div className='my-4 d-flex flex-column gap-4'>
                    {(userAccessDataLoading || useAccessDataValidating) && (
                      <div>
                        <div className='loading-overlay'>
                          <div className='loader'></div>
                        </div>
                      </div>
                    )}
                    {!useAccessDataValidating && formik.values.dataUsers.length <= 0 &&
                      userAccessDataTemp.map((user: IDataUser) => {
                        return (
                          <div className='row align-items-center'>
                             <div className='col-8 d-flex align-items-center gap-4'>
                                <div className='symbol symbol-45px symbol-circle'>
                                    <span className='symbol-label bg-light-danger text-danger fs-6 fw-bolder'>
                                        <img alt={user.name} src={toAbsoluteUrl('/media/logos/logo-wooblazz.png')} className='symbol symbol-45px symbol-circle img-fluid' style={{ padding: "10px" }}  />
                                    </span>
                                </div>
                                <span>
                                  {user.name}
                                </span>
                                </div>
                            <div className='col-4'>
                              <Select
                                options={roleAnalyticOptionWithRemove}
                                value={roleAnalyticOptionWithRemove.filter((option) => {
                                  return option.value === user.access
                                })}
                                onChange={(selectedOption) => {
                                  if (!selectedOption) return
                                  const index = userAccessDataTemp.findIndex((data: IDataUser) => {
                                    return data.userId === user.userId
                                  })

                                  const newUserAccessData = userAccessDataTemp.map(
                                    (data: IDataUser, i) => {
                                      if (i === index) {
                                        return {...data, access: selectedOption.value}
                                      }
                                      return data
                                    }
                                  )
                                  setUserAccessDataTemp([...newUserAccessData])
                                }}
                                components={{Option}}
                                styles={customStyles}
                              />
                            </div>
                          </div>
                        )
                      })}
                    {!useAccessDataValidating && formik.values.dataUsers.length > 0 &&
                      userAccessData.map((user: IDataUser) => {
                        return (
                          <div className='row align-items-center'>
                            <div className='col-8 d-flex align-items-center gap-4'>
                                <div className='symbol symbol-45px symbol-circle'>
                                    <span className='symbol-label bg-light-danger text-danger fs-6 fw-bolder'>
                                        <img alt={user.name} src={toAbsoluteUrl('/media/logos/logo-wooblazz.png')} className='symbol symbol-45px symbol-circle img-fluid' style={{ padding: "10px" }}  />
                                    </span>
                                </div>
                                <span>
                                  {user.name}
                                </span>
                                </div>
                            <div className='col-4'>
                              <Select
                                isDisabled
                                options={roleAnalyticOptionWithRemove}
                                value={roleAnalyticOptionWithRemove.filter((option) => {
                                  return option.value === user.access
                                })}
                                components={{Option}}
                                styles={customStyles}
                                onChange={(selectedOption) => {
                                  if (!selectedOption) return
                                  const index = userAccessData.findIndex((data: IDataUser) => {
                                    return data.userId === user.userId
                                  })

                                  const newUserAccessData = userAccessData.map(
                                    (data: IDataUser, i) => {
                                      if (i === index) {
                                        return {...data, access: selectedOption.value}
                                      }
                                      return data
                                    }
                                  )
                                  setUserAccessData([...newUserAccessData])
                                  
                                }}
                              />
                            </div>
                          </div>
                        )
                      })}
                  </div>
                </div>
              </div>
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn btn-light d-none'
                  data-bs-dismiss='modal'
                  ref={closeModalRef}
                >
                  {intl.formatMessage({id: 'FORM.ACTION.CANCEL'})} tes
                </button>
                <button type='button' className='btn btn-light' onClick={handleCloseModal}>
                  {intl.formatMessage({id: 'FORM.ACTION.CANCEL'})}
                </button>
                {formik.values.dataUsers.length <= 0 && (
                  <button
                    onClick={handleUpdateRole}
                    className={`btn btn-primary me-10 ${updateRoleBTNLoading ? 'disabled' : ''}`}
                    data-kt-indicator={updateRoleBTNLoading ? 'on' : 'off'}
                  >
                    <span className='indicator-label'>
                      {areAnyUpdate
                        ? intl.formatMessage({id: 'FORM.ACTION.UPDATE'})
                        : intl.formatMessage({id: 'FORM.ACTION.DONE'})}
                    </span>
                    <span className='indicator-progress'>
                      Loading...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </button>
                )}

                {formik.values.dataUsers.length > 0 && (
                  <button
                    type='button'
                    className={`btn btn-primary me-10 ${addRoleBTNLoading ? 'disabled' : ''}`}
                    data-kt-indicator={addRoleBTNLoading ? 'on' : 'off'}
                    onClick={handleAddRole}
                  >
                    <span className='indicator-label'>
                      {intl.formatMessage({id: 'FORM.ACTION.ADD'})}
                    </span>
                    <span className='indicator-progress'>
                      Loading...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </button>
                )}
              </div>
            </form>
            {/* form */}
          </div>
        </div>
      </div>
    </>
  )
}
